module.exports = __webpack_public_path__ + "img/image4.c1c8fb01.jpg";